import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10.5",
  stroke: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10.184 12.576q0-.364.238-.602a.8.8 0 0 1 .602-.252q.574 0 1.036-.168.461-.182.728-.574.28-.392.28-1.036a1.5 1.5 0 0 0-.238-.84 1.57 1.57 0 0 0-.63-.574q-.392-.21-.896-.21a2 2 0 0 0-.742.14 2.3 2.3 0 0 0-.616.378q-.224.196-.546.294-.307.084-.63-.154-.336-.252-.364-.602t.266-.644a3.5 3.5 0 0 1 1.176-.798 3.7 3.7 0 0 1 1.456-.294q.966 0 1.736.448.784.434 1.246 1.176t.462 1.68q0 .7-.21 1.246-.21.533-.602.924-.377.378-.896.616-.504.225-1.106.322l-.056.028q-.015.014-.014.042v.518q0 .364-.238.616a.82.82 0 0 1-.602.238.82.82 0 0 1-.602-.238.86.86 0 0 1-.238-.616zm.77 4.424q-.405 0-.63-.21-.21-.225-.21-.63v-.238q0-.405.21-.616.225-.225.63-.224h.182q.406 0 .616.224.225.21.224.616v.238q0 .405-.224.63-.21.21-.616.21z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }